import React from "react";
import { Box, useTheme } from "@mui/material";
import Skeleton from "react-loading-skeleton";
import "react-loading-skeleton/dist/skeleton.css";
import HeaderTab from "./header_tab";
import { HeaderInfo } from "../../types";

interface HeaderTabsProps {
  isLoading: boolean;
  resultAvailable: boolean | null;
  headersInfo: HeaderInfo[];
  selectedTab: string;
  onTabClick: (header: HeaderInfo) => void;
  onTabClear: (header: HeaderInfo) => void;
}

const HeaderTabs: React.FC<HeaderTabsProps> = ({
  isLoading,
  resultAvailable,
  headersInfo,
  selectedTab,
  onTabClick,
  onTabClear,
}) => {
  const theme = useTheme();
  const isDark = theme.palette.mode === "dark";
  const baseColor = isDark ? "#3c3c3c" : "#e0e0e0";
  const highlightColor = isDark ? "#525252" : "#f5f5f5";

  if (isLoading) {
    return (
      <Box
        className="search-results-tabs"
        display="flex"
        flexWrap="wrap"
        gap={1}
      >
        {Array.from({ length: headersInfo.length || 5 }).map((_, index) => (
          <Skeleton
            key={index}
            width={100}
            height={30}
            baseColor={baseColor}
            highlightColor={highlightColor}
            style={{ borderRadius: "8px" }}
          />
        ))}
      </Box>
    );
  }

  if (!resultAvailable) {
    return null;
  }

  return (
    <Box className="search-results-tabs" display="flex" flexWrap="wrap">
      {headersInfo.map((header, index) => (
        <HeaderTab
          key={index}
          header={header}
          index={index}
          onTabClick={onTabClick}
          onTabClear={onTabClear}
          selectedTab={selectedTab}
        />
      ))}
    </Box>
  );
};

export default HeaderTabs;
